import { STORAGE_KEYS } from 'src/utils/TabsLocalStorage';
import { STORE_WEBSOCKET_CONTAINER } from '../../constants/action-types';

const getInitialState = () => {
  return {
    container: null,
    browser_tab: `${Date.now()}_${Math.random()}`,
  };
};

const initialState = getInitialState();

localStorage.setItem(STORAGE_KEYS.BROWSER_TAB, initialState.browser_tab);

const websocket = (state = initialState, action) => {
  const types = {
    [STORE_WEBSOCKET_CONTAINER]: () => ({
      ...state,
      container: action.payload.container,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default websocket;
